import EssayPrizePageLayout from "./EssayPrizePageLayout";
import { OverviewPrizeCard } from "./EssayPrizeCard";
import { ESSAY_PRIZE_CATEGORIES } from "./essayPrizes";

const NationalEssayPrizesPage = () => {
  return (
    <EssayPrizePageLayout
      compactFooterSpacing
      heroLabel="National competition · 2026"
      heroTitle={
        <>
          National <span className="tml-hero__title-accent">Essay Prizes</span>
        </>
      }
      heroLead={
        <>
          Two <strong>£500 national prizes</strong> for UK medical students, foundation doctors, specialist
          trainees, and fellows. Choose the category that matches your career stage.
        </>
      }
    >
      <section className="nep-section nep-intro">
        <p className="nep-intro__text">
          OphthalmologyQ is proud to announce the inaugural National Essay Prizes across the United Kingdom—designed
          to foster scholarly thinking and celebrate the next generation of ophthalmic clinicians and academics.
        </p>
      </section>

      <section className="nep-section" aria-labelledby="nep-prizes-heading">
        <h2 id="nep-prizes-heading" className="nep-section__title">
          Prize categories
        </h2>
        <div className="nep-prize-grid">
          {ESSAY_PRIZE_CATEGORIES.map((category) => (
            <OverviewPrizeCard key={category.slug} category={category} />
          ))}
        </div>
      </section>
    </EssayPrizePageLayout>
  );
};

export default NationalEssayPrizesPage;
